import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";

@Injectable()
export class OtherService {
	constructor(private httpclientService: HttpclientService) {}

	ClassAttendanceExcuseGetList() {
		var postResult$ = new Subject();
		var url = "attendance/ClassAttendanceExcuseGetList";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
